(() => {
  'use strict';
  const root = document.getElementById('clc-passion');
  const node = document.getElementById('clc-passion-data');
  if (!root || !node || !window.PassionCommerce) return;
  const data = JSON.parse(node.textContent);
  const local = document.body.dataset.localPreview === 'true';
  if (data.source !== 'shopify-liquid' && !local) return;
  const media = matchMedia('(min-width:1200px)');
  const state = {size: '30', choice: 'bundle', mode: 'subscription', weeks: '4', gallery: 0, open: 't1', busy: false, uncertain: false};
  // Variant links select only one of this product's known count options.
  const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
  const requestedVariant = data.variants.find(item => String(item.id) === requestedVariantId);
  if (requestedVariant && ['12 Count', '30 Count'].includes(requestedVariant.title)) {
    state.size = requestedVariant.title === '12 Count' ? '12' : '30';
  }

  const all = selector => [...root.querySelectorAll(selector)];
  const money = cents => new Intl.NumberFormat(data.locale || 'en-US', {style: 'currency', currency: data.currency}).format(cents / 100);
  const resolve = () => window.PassionCommerce.resolve(data, state.size === '12'
    ? {size: '12', mode: state.mode, weeks: state.weeks}
    : {size: '30', choice: state.choice});
  const resolve30 = choice => window.PassionCommerce.resolve(data, {size: '30', choice});
  const resolve12 = (mode, weeks = state.weeks) => window.PassionCommerce.resolve(data, {size: '12', mode, weeks});
  const variant = size => data.variants.find(item => item.title === `${size} Count`);
  const route = path => `${String(data.root || '/').replace(/\/$/, '')}/${path}`;
  let observer, frame, message = '';

  function status(text) {
    message = text;
    const el = root.querySelector('[data-commerce-status]');
    el.textContent = text;
    el.hidden = !text;
  }

  function syncSizeChrome() {
    for (const el of all('[data-size]')) {
      const selected = el.dataset.size === state.size;
      el.classList.toggle('on', selected);
      el.setAttribute('aria-pressed', String(selected));
    }
    for (const panel of all('[data-commerce-panel]')) {
      panel.hidden = panel.dataset.commercePanel !== state.size;
    }
    all('[data-size-details]').forEach(el => { el.textContent = state.size === '12' ? '12 gummies' : '30 gummies'; });
  }

  function applySizeImage() {
    const image = variant(state.size)?.featuredImage;
    all('[data-size-image]').forEach(el => {
      if (!el.dataset.defaultSrc) el.dataset.defaultSrc = el.getAttribute('src');
      // Keep the merchant's 30-count picker value; prefer its separate 12-count picker.
      el.src = state.size === '12' ? (el.dataset.size12Src || image || el.dataset.defaultSrc) : el.dataset.defaultSrc;
    });
  }

  function sync30() {
    for (const el of all('[data-choice]')) {
      const selected = el.dataset.choice === state.choice;
      el.classList.toggle('on', selected);
      el.setAttribute('aria-pressed', String(selected));
      el.querySelector('.dot')?.classList.toggle('on', selected);
    }
    for (const choice of ['once', 'single', 'bundle']) {
      const offer = resolve30(choice);
      const priced = Number.isInteger(offer.price) && Number.isInteger(offer.compare);
      for (const el of all(`[data-offer-price="${choice}"]`)) el.textContent = priced ? money(offer.price) : 'Unavailable';
      for (const el of all(`[data-offer-compare="${choice}"]`)) el.textContent = priced ? money(offer.compare) : '';
      for (const el of all(`[data-offer-saving="${choice}"]`)) el.textContent = priced ? `SAVE ${Math.round((1 - offer.price / offer.compare) * 100)}%` : 'SUBSCRIBE';
    }
    const single = resolve30('single');
    const singleSaving = Number.isInteger(single.price) && Number.isInteger(single.compare) && single.compare > 0
      ? Math.round(100 * (1 - single.price / single.compare)) : 0;
    all('[data-offer-discount="single"]').forEach(el => {
      el.textContent = singleSaving > 0 ? `${singleSaving}% off every order` : 'Recurring delivery';
    });
    all('[data-shipping-copy]').forEach(el => { el.textContent = data.shippingApproved ? 'Free standard US shipping on every delivery' : 'Shipping calculated at checkout'; });
  }

  function sync12() {
    for (const el of all('[data-mode]')) {
      const selected = el.dataset.mode === state.mode;
      el.classList.toggle('on', selected);
      el.setAttribute('aria-pressed', String(selected));
      el.querySelector('.dot')?.classList.toggle('on', selected);
      const input = el.querySelector('input[type="radio"]');
      if (input) input.checked = selected;
    }
    const frequency = root.querySelector('.freq');
    const weeks = Object.keys(data.binding?.['12']?.plans || {4: true});
    if (frequency) {
      frequency.replaceChildren(...weeks.map(value => {
        const plan = resolve12('subscription', value).plan;
        const option = new Option(plan?.name || `Delivered every ${value} weeks`, value);
        option.disabled = !plan;
        return option;
      }));
      if (![...frequency.options].some(option => option.value === state.weeks && !option.disabled)) {
        const first = [...frequency.options].find(option => !option.disabled);
        if (first) state.weeks = first.value;
      }
      frequency.value = state.weeks;
      frequency.disabled = ![...frequency.options].some(option => !option.disabled);
    }
    const freqWrap = root.querySelector('[data-freq]');
    if (freqWrap) freqWrap.hidden = state.mode !== 'subscription';
    const once = resolve12('once');
    const sub = resolve12('subscription');
    all('[data-price-once]').forEach(el => { el.textContent = Number.isInteger(once.price) ? money(once.price) : 'Unavailable'; });
    all('[data-price-subscription]').forEach(el => { el.textContent = Number.isInteger(sub.price) ? money(sub.price) : 'Unavailable'; });
    all('[data-price-compare]').forEach(el => { el.textContent = Number.isInteger(sub.compare) ? money(sub.compare) : ''; });
    const saving = Number.isInteger(sub.price) && Number.isInteger(sub.compare) && sub.compare > 0
      ? Math.round(100 * (1 - sub.price / sub.compare))
      : 0;
    all('[data-saving]').forEach(el => { el.textContent = saving > 0 ? `SAVE ${saving}%` : 'SUBSCRIBE'; });
    all('[data-saving-copy]').forEach(el => { el.textContent = saving > 0 ? `${saving}% off every order` : 'Recurring delivery'; });
  }

  function sync() {
    syncSizeChrome();
    if (state.size === '12') sync12();
    else sync30();
    const offer = resolve();
    all('[data-add]').forEach(el => {
      el.disabled = !!offer.error || state.busy || state.uncertain;
      el.setAttribute('aria-busy', String(state.busy));
      el.textContent = state.busy ? 'ADDING...' : 'ADD TO BAG';
    });
    status(message || offer.error || '');
  }

  function sticky() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const bar = root.querySelector('[data-pagesmith-sticky]');
      const marker = root.querySelector('#m-sticky-start');
      const visible = !!bar && !!marker && marker.getBoundingClientRect().bottom < 0 && !media.matches;
      if (bar) {
        bar.classList.toggle('on', visible);
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
      }
      root.style.setProperty('--passion-sticky-space', visible ? `${bar.getBoundingClientRect().height}px` : '0px');
    });
  }

  function gallery() {
    all('[data-slide]').forEach((el, i) => { el.style.display = i === state.gallery ? 'block' : 'none'; });
    all('[data-thumb]').forEach((el, i) => {
      el.classList.toggle('on', i === state.gallery);
      el.setAttribute('aria-pressed', String(i === state.gallery));
    });
  }

  function accordions() {
    all('.tab-h,.faq-t').forEach(el => {
      const id = el.getAttribute('aria-controls');
      const on = id.slice(2) === state.open;
      el.setAttribute('aria-expanded', String(on));
      root.querySelector('#' + id).hidden = !on;
    });
    sticky();
  }

  async function readCart() {
    const response = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error('Unable to read your bag.');
    return response.json();
  }

  const matchingQuantity = (cart, item) => cart.items
    .filter(line => String(line.variant_id) === String(item.id) && String(line.selling_plan_allocation?.selling_plan?.id || '') === String(item.selling_plan || ''))
    .reduce((n, line) => n + line.quantity, 0);

  async function add() {
    if (state.busy || state.uncertain) return;
    const offer = resolve();
    if (offer.error) return status(offer.error);
    if (local) return status('Local preview only. No item was added to a Shopify cart.');
    state.busy = true;
    message = '';
    sync();
    let before, attempted = false;
    try {
      before = await readCart();
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.().map(s => s.section) || [];
      const payload = {items: [offer.item], sections, sections_url: location.pathname};
      attempted = true;
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'We could not add this option. Please check your bag.');
      }
      const result = await response.json();
      const after = await readCart();
      if (matchingQuantity(after, offer.item) - matchingQuantity(before, offer.item) !== offer.item.quantity) {
        throw new Error('Your bag changed unexpectedly. Please check it before adding again.');
      }
      if (drawer?.renderContents && sections.every(id => result.sections?.[id])) await drawer.renderContents(result, true);
      else {
        state.uncertain = true;
        status('Your item was added. Open your bag to review it.');
        return;
      }
      status('Added to your bag.');
    } catch (error) {
      if (attempted) {
        try {
          const current = await readCart();
          const delta = matchingQuantity(current, offer.item) - matchingQuantity(before, offer.item);
          state.uncertain = delta !== 0;
          if (delta === offer.item.quantity) {
            status('Your item was added. Open your bag to review it before adding again.');
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else status(error.message);
        } catch {
          state.uncertain = true;
          status('We could not confirm whether the item was added. Please check your bag before trying again.');
        }
      } else status(error.message);
    } finally {
      state.busy = false;
      sync();
    }
  }

  function setSize(size) {
    if (state.size === size) return;
    state.size = size;
    state.choice = 'bundle';
    state.mode = 'subscription';
    state.weeks = '4';
    state.gallery = 0;
    message = '';
    applySizeImage();
    gallery();
    sync();
  }

  function mount() {
    observer?.disconnect();
    const template = document.getElementById(media.matches ? 'clc-passion-desktop' : 'clc-passion-mobile');
    root.replaceChildren(template.content.cloneNode(true));
    applySizeImage();
    sync();
    gallery();
    accordions();
    observer = new ResizeObserver(sticky);
    observer.observe(root);
    root.querySelectorAll('img').forEach(img => img.addEventListener('load', sticky, {once: true}));
  }

  root.addEventListener('click', event => {
    if (event.target.closest('select, a')) return;
    const sizeEl = event.target.closest('[data-size]');
    if (sizeEl) return setSize(sizeEl.dataset.size);
    const modeEl = event.target.closest('[data-mode]');
    if (modeEl) {
      state.mode = modeEl.dataset.mode;
      message = '';
      return sync();
    }
    const el = event.target.closest('button');
    if (!el) return;
    if (el.matches('[data-choice]')) {
      const changed = state.choice !== el.dataset.choice;
      state.choice = el.dataset.choice;
      message = '';
      sync();
      if (changed && state.choice === 'once') add();
    } else if (el.matches('[data-thumb]')) {
      state.gallery = all('[data-thumb]').indexOf(el);
      gallery();
    } else if (el.matches('.tab-h,.faq-t')) {
      const id = el.getAttribute('aria-controls').slice(2);
      state.open = state.open === id ? null : id;
      accordions();
    } else if (el.matches('[data-add]')) add();
    else if (el.matches('[data-open-cart]')) {
      if (local) status('Local preview only. Your Shopify cart has not changed.');
      else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    } else if (el.matches('[data-open-menu]')) document.getElementById('clc-passion-menu')?.showModal();
  });

  root.addEventListener('change', event => {
    if (event.target.matches('.freq')) {
      state.weeks = event.target.value;
      message = '';
      return sync();
    }
    if (event.target.matches('input[type="radio"][name^="purchase-mode"]')) {
      state.mode = event.target.value;
      message = '';
      return sync();
    }
  });

  document.querySelector('[data-close-menu]')?.addEventListener('click', () => document.getElementById('clc-passion-menu').close());
  addEventListener('scroll', sticky, {passive: true});
  addEventListener('resize', sticky);
  media.addEventListener('change', mount);
  mount();
})();
